export const withLogic =
  (Component: React.ComponentType<any>): React.FC<any> =>
  (props: any) => {
    return (
      <Component
        {...{
          ...props,
          ariaLabel:
            props.state === 'selected' ? props.ariaLabel : `${props.value}`,
          _ariaCurrent: props.state === 'current' ? 'date' : undefined,
          _ariaChecked: props.state === 'selected' ? 'true' : 'false',
          onClick: () => {
            props.onClick?.(props.internalIndex, props.disabled);
          }
        }}
      />
    );
  };
